import styled from "styled-components";

export const CustomModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-end;
`;
